import { render, staticRenderFns } from "./editStaticPagesOnly.vue?vue&type=template&id=21a7e1a8"
import script from "./editStaticPagesOnly.vue?vue&type=script&lang=js"
export * from "./editStaticPagesOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports